import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';

import API from 'configs/API';
import { USER_ROLE_BY_KEY } from 'configs/Constant';
import useRole from 'hooks/useRole';

import OriginalTabContent from './OriginalTabContent';
import PublicShareTabContent from './PublicShareTabContent';
import useStyles from './styles';

const GalleryTabContent = ({
  userProfile,
  roleUser,
  isPublicShare = false,
  shareType,
  userUuid,
}) => {
  const classes = useStyles();
  const { id } = useParams();

  const user = useSelector((state) => state.auth.account.user);
  const isOwner = user?.uuid === id;
  const [searchParams, setSearchParams] = useSearchParams();
  const numberTabValue = isOwner || isPublicShare ? 1 : 4;
  const tabValue = Number(searchParams.get('tab') || numberTabValue);
  const { isCollectorOrGalleryOwner, isArtist } = useRole(roleUser);
  const pageOwnerIsCollector = roleUser === USER_ROLE_BY_KEY.COLLECTOR;

  const { data: artworksCount } = useQuery({
    queryKey: [API.ARTWORK.ARTWORK_COUNT, { owner_uuid: id }],
    enabled: !isPublicShare,
  });
  const { data: collectionsCount } = useQuery({
    queryKey: [API.ARTWORK.COLLECTION_COUNT, { owner_uuid: id }],
    enabled: !isPublicShare,
  });
  const { data: exhibitionCount } = useQuery({
    queryKey: [API.ARTWORK.EXHIBITION_COUNT, { owner_uuid: id }],
    enabled: !isPublicShare && isArtist,
  });
  const { data: artistCount } = useQuery({
    queryKey: [API.ARTWORK.ARTIST_COUNT],
    enabled: !isPublicShare && isCollectorOrGalleryOwner && isOwner,
  });

  const handleTabChange = (e, newValue) => {
    searchParams.set('tab', newValue);
    searchParams.delete('search');
    searchParams.delete('page');
    searchParams.delete('ordering');
    setSearchParams(searchParams, { replace: true });
  };

  const getLabel = ({ text, number }) => {
    return `${text} ${number}`;
  };

  const isCollectorOwner = isCollectorOrGalleryOwner && isOwner;
  const isCollectorPublic = isCollectorOrGalleryOwner;

  if (isPublicShare) {
    return (
      <PublicShareTabContent
        classes={classes}
        tabValue={tabValue}
        handleTabChange={handleTabChange}
        getLabel={getLabel}
        shareType={shareType}
        isCollectorPublic={isCollectorPublic}
        isArtist={isArtist}
        userProfile={userProfile}
        userUuid={userUuid}
        pageOwnerIsCollector={pageOwnerIsCollector}
      />
    );
  }

  return (
    <OriginalTabContent
      classes={classes}
      tabValue={tabValue}
      handleTabChange={handleTabChange}
      getLabel={getLabel}
      isOwner={isOwner}
      isCollectorOwner={isCollectorOwner}
      isArtist={isArtist}
      artworksCount={artworksCount}
      collectionsCount={collectionsCount}
      exhibitionCount={exhibitionCount}
      artistCount={artistCount}
      userProfile={userProfile}
      userUuid={userUuid}
      pageOwnerIsCollector={pageOwnerIsCollector}
    />
  );
};

export default GalleryTabContent;
